import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Row,
  CardTitle,
} from "reactstrap";
import * as moment from "moment";
import BreadCrumb from "../../Components/Common/BreadCrumb";

//redux
import { useSelector, useDispatch } from "react-redux";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

//Import actions
import {
  getImports as onGetImports,
  updateRow as onUpdateRow,
  updateStatus as onUpdateStatus,
  getSuppliers as onGetSuppliers,
} from "../../slices/thunks";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import keepaImg from "../../assets/images/brands/keepa.png";

import { createSelector } from "reselect";

//AG GRID
import NumericEditor from "../../Components/Common/numericEditor";
import CustomInnerHeader from "../../Components/Common/CustomInnerHeader.jsx";
import PendingOrdersPopup from "../../Components/Common/PendingOrdersPopup";

import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry, CsvExportModule } from "ag-grid-community";
import {
  AllEnterpriseModule,
  LicenseManager,
  ExcelExportModule,
} from "ag-grid-enterprise";
import { productsStatus } from "../../Components/constants/layout";
import RejectModal from "../../Components/Common/RejectModal";
import StatusUpdateResultModal from "../../Components/Common/StatusUpdateResultModal";
import RestrictChannelsModal from "../../Components/Common/RestrictChannelsModal.js";
import ColourCellRenderer from "../../Components/Common/colourCellRender.js";

ModuleRegistry.registerModules([
  CsvExportModule,
  ExcelExportModule,
  AllEnterpriseModule,
]);
LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-076901}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cartzy}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{BCAT}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{BCAT}_need_to_be_licensed___{BCAT}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{11_February_2026}____[v3]_[01]_MTc3MDc2ODAwMDAwMA==4a557ef1e71d7e706797c31212266eae"
);

const FinalAnalysis = () => {
  const [modal, setModal] = useState(false);
  const [resultModal, setResultModal] = useState(false);
  const [updateResult, setUpdateResult] = useState(null);
  const [showRestrictChannels, setShowRestrictChannels] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedAnalysisStatus, setSelectedAnalysisStatus] = useState([
    { label: "Working", value: 3 },
  ]);
  const [selectedSalesChannels, setSelectedSalesChannels] = useState([]);
  const [suppliersList, setSuppliersList] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [dateFrom, setDateFrom] = useState(moment());
  const [dateTo, setDateTo] = useState(moment());
  const gridApi = useRef(null);
  const excelStyles = useMemo(() => {
    return [
      {
        id: "numberType",
        numberFormat: {
          format: "0",
        },
      },
      {
        id: "currencyFormat",
        numberFormat: {
          format: "#,##0.00 €",
        },
      },
      {
        id: "negativeInBrackets",
        numberFormat: {
          format: "$[blue] #,##0;$ [red](#,##0)",
        },
      },
      {
        id: "booleanType",
        dataType: "Boolean",
      },
      {
        id: "stringType",
        dataType: "String",
      },
      {
        id: "dateType",
        dataType: "DateTime",
      },
    ];
  }, []);

  const analysisStatus = [
    {
      options: [
        { label: "Published", value: 0 },
        { label: "Working", value: 3 },
        { label: "Rejected", value: 6 },
        { label: "Ready For Import", value: 2 },
      ],
    },
  ];
  const salesChannels = [
    { label: "FBA", value: "FBA" },
    { label: "FBM", value: "FBM" },
    { label: "eBay", value: "ebay" },
    { label: "Walmart", value: "walmart" },
    { label: "Other", value: "other" },
    { label: "Online Store", value: "online" },
    { label: "LIQUIDATIONS", value: "liquidations" },
  ];
  const dispatch = useDispatch();

  const selectFilesData = createSelector(
    (state) => state.Analysis,
    (imports) => imports,
    (updatedStatus) => updatedStatus,
    (updatedRow) => updatedRow,
    (error) => error
  );
  const selectSuppliersData = createSelector(
    (state) => state.Suppliers.suppliers,
    (suppliers) => suppliers
  );

  const suppliers = useSelector(selectSuppliersData);

  const { imports, updatedStatus, updatingStatus, error } = useSelector(selectFilesData);

  const [rowData, setRowData] = useState([]);
  const rowSelection = {
    mode: "multiRow",
    headerCheckbox: true,
  };

  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderMenuButton: true,
      headerComponentParams: {
        innerHeaderComponent: CustomInnerHeader,
      },
    };
  }, []);

  const saveNewValue = (params) => {
    return false;
  };

  const getSelectedSalesChannels = () => {
    let salesChannel = 0;

    selectedSalesChannels.forEach((item) => {
      switch (item.value) {
        case "FBA":
          salesChannel += 1;
          break;
        case "FBM":
          salesChannel += 2;
          break;
        case "eBay":
          salesChannel += 4;
          break;
        case "walmart":
          salesChannel += 8;
          break;
        case "other":
          salesChannel += 16;
          break;
        case "online":
          salesChannel += 32;
          break;
        case "liquidations":
          salesChannel += 64;
          break;
        default:
          break;
      }
    });
    return salesChannel;
  };

  const getImports = () => {
    const status = selectedAnalysisStatus.map((item) => item.value);
    if (status.indexOf(6) > -1) {
      status.push(7);
      status.push(8);
    }
    dispatch(
      onGetImports({
        status: status.length > 0 ? status : null,
        sup_id: supplier.length > 0 ? supplier.map((item) => item.value) : null,
        date_from: moment(dateFrom).format("YYYY-MM-DD"),
        date_to: moment(dateTo).format("YYYY-MM-DD"),
        current_status: productsStatus.STATUS_READYFORFINAL,
      })
    );
  };

  const getShipToWarehouse = (params) => {
    return params.data.imp_packageWeight > 0 &&
      params.data.imp_packageWeight <= 8
      ? 1.5
      : params.data.imp_packageWeight > 8 && params.data.imp_packageWeight <= 16
      ? 3.1
      : params.data.imp_packageWeight > 16 &&
        params.data.imp_packageWeight <= 24
      ? 4.65
      : params.data.imp_packageWeight > 24 &&
        params.data.imp_packageWeight <= 32
      ? 6.2
      : 0;
  };

  const getShipToAmazon = (params) => {
    return params.data.imp_FBA &&
      params.data.imp_fulfillmentSubtotal < 10 &&
      params.data.imp_fulfillmentSubtotal > 0
      ? 2
      : params.data.imp_FBA &&
        params.data.imp_fulfillmentSubtotal >= 10 &&
        params.data.imp_fulfillmentSubtotal < 20
      ? 3
      : params.data.imp_FBA &&
        params.data.imp_fulfillmentSubtotal >= 20 &&
        params.data.imp_fulfillmentSubtotal < 30
      ? 4
      : params.data.imp_FBA &&
        params.data.imp_fulfillmentSubtotal >= 30 &&
        params.data.imp_fulfillmentSubtotal < 40
      ? 5
      : params.data.imp_FBA &&
        params.data.imp_fulfillmentSubtotal >= 40 &&
        params.data.imp_fulfillmentSubtotal < 50
      ? 6
      : params.data.imp_FBA && params.data.imp_fulfillmentSubtotal >= 50
      ? 8
      : 0;
  };

  const getShipToCustomer = (params) => {
    return params.data.imp_FBM &&
      params.data.imp_packageWeight > 0 &&
      params.data.imp_packageWeight <= 1
      ? 5.96
      : params.data.imp_FBM &&
        params.data.imp_packageWeight > 1 &&
        params.data.imp_packageWeight <= 2
      ? 7.64
      : params.data.imp_FBM &&
        params.data.imp_packageWeight > 2 &&
        params.data.imp_packageWeight <= 3
      ? 8.86
      : params.data.imp_FBM &&
        params.data.imp_packageWeight > 3 &&
        params.data.imp_packageWeight <= 4
      ? 9.69
      : params.data.imp_FBM &&
        params.data.imp_packageWeight > 4 &&
        params.data.imp_packageWeight <= 5
      ? 10.13
      : params.data.imp_FBM &&
        params.data.imp_packageWeight > 5 &&
        params.data.imp_packageWeight <= 6
      ? 10.34
      : params.data.imp_FBM &&
        params.data.imp_packageWeight > 6 &&
        params.data.imp_packageWeight <= 7
      ? 10.64
      : params.data.imp_FBM &&
        params.data.imp_packageWeight > 7 &&
        params.data.imp_packageWeight <= 8
      ? 10.69
      : params.data.imp_FBM &&
        params.data.imp_packageWeight > 8 &&
        params.data.imp_packageWeight <= 9
      ? 10.78
      : params.data.imp_FBM &&
        params.data.imp_packageWeight > 9 &&
        params.data.imp_packageWeight <= 10
      ? 11.74
      : params.data.imp_FBM &&
        params.data.imp_packageWeight > 10 &&
        params.data.imp_packageWeight <= 21
      ? 11.79
      : 0;
  };

  const asinRendererWithPopup = (params) => {
    const hasOrders = params.data.imp_customerOrderIds && params.data.imp_customerOrderIds.trim() !== "";
    const targetId = `asin-info-${params.data.imp_id}`;
    
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {hasOrders && (
          <PendingOrdersPopup 
            orderIds={params.data.imp_customerOrderIds} 
            targetId={targetId}
          />
        )}
        <a href={params.data.imp_amazonLink} target="_blank">
          {params.data.imp_ASIN}
        </a>
      </div>
    );
  };

  const keepaLinkRenderer = (params) => {
    return (
      <center>
        <a href={params.data.imp_keepaLink} target="_blank">
          <img alt={`keepa link logo`} src={keepaImg} className="logo" />
        </a>
      </center>
    );
  };

  const cellNetProfitRules = {
    "cell-netProfit-fail": (params) => params.value < 2,
    "cell-netProfit-success": (params) => params.value >= 2,
  };

  const cellSellingPriceRules = {
    "cell-sellingPrice-fail": (params) => params.value < 2,
    "cell-sellingPrice-success": (params) => params.value >= 2,
  };

  // Column Definitions: Defines the columns to be displayed.
  const [colDefs, setColDefs] = useState([
    {
      headerName: "ASIN",
      field: "imp_ASIN",
      pinned: "left",
      filter: true,
      suppressMovable: true,
      headerStyle: { "background-color": "#90EE90" },
      cellRenderer: asinRendererWithPopup,
      cellClass: "age-border",
    },
    {
      headerName: "UPC",
      field: "imp_UPC",
      pinned: "left",
      headerStyle: { "background-color": "#90EE90" },
      suppressMovable: true,
      cellClass: "stringType",
    },
    {
      headerName: "Product ID",
      field: "imp_productID",
      pinned: "left",
      suppressMovable: true,
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "stringType",
    },
    {
      headerName: "Last Run",
      field: "imp_lastModifiedDate",
      minWidth: 180,
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      cellRenderer: (params) => {
        return moment(params.value).format("MM/DD/YYYY hh:mm A");
      },
    },
    {
      headerName: "Brand",
      field: "imp_brand",
      headerStyle: { "background-color": "#90EE90" },
      minWidth: 250,
      cellClass: "age-border",
      editable: (params) =>
        params?.data?.imp_salesChannel &&
        params.data.imp_salesChannel.toString().toLowerCase() === "liquidations",
      valueSetter: saveNewValue,
    },
    {
      headerName: "Title",
      field: "imp_title",
      minWidth: 250,
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      editable: (params) =>
        params?.data?.imp_salesChannel &&
        ["liquidations", "ebay"].includes(
          params.data.imp_salesChannel.toString().toLowerCase()
        ),
      valueSetter: saveNewValue,
    },
    {
      headerName: "Keepa Link",
      field: "imp_KeepaLink",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      cellRenderer: keepaLinkRenderer,
    },
    {
      headerName: "Pack Qty. (check title)",
      field: "imp_packQuantity",
      editable: true,
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
    },
    {
      headerName: "Vendor Cost",
      field: "imp_vendorCost",
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
      editable: true,
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },
    {
      headerName: "Product Rating",
      field: "imp_productRating",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "New FBA Offers",
      field: "imp_newFBAOffers",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "New FBM Offers",
      field: "imp_newFBMOffers",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Est Sales",
      field: "imp_estimatedSales",
      editable: (params) =>
        params?.data?.imp_salesChannel &&
        ["liquidations", "ebay"].includes(
          params.data.imp_salesChannel.toString().toLowerCase()
        ),
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Sales Rank",
      field: "imp_salesRank",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Avg Sales Rank 90d",
      field: "imp_avgSalesRank90Days",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Bought In Past Month",
      field: "imp_boughtInPastMonth",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Variants",
      field: "imp_variants",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Reviews",
      field: "imp_reviews",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "New Estimated Sales",
      field: "imp_newEstimatedSales",
      headerTooltip:
        "if(variants == 0) { est sales * 1 } else if (variants > 0 && variants <= 2) { est sales * 0.8 } else if (variants > 2 && variants <= 5) { est sales * 0.7 } else if (variants > 5 && variants <= 8) { est sales * 0.6 } else if (variants > 8 && variants <= 12) { est sales * 0.55 } else if (variants > 12 && variants <= 15) { est sales * 0.5 } else if (variants > 15 && variants <= 19) { est sales * 0.45 } else if (variants > 19 && variants <= 25) { est sales * 0.4 } else if (variants > 25 && variants <= 30) { est sales * 0.3 } else if (variants > 30) { est sales * 0.2 }",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      /*valueGetter: (params) => {
        //IFS(Q3=0, P3*1, Q3<=2, P3*0.8, Q3<=5, P3*0.7, Q3<=8, P3*0.6, Q3<=12, P3*0.55, Q3<=15, P3*0.5, Q3<=19, P3*0.45, Q3<=25, P3*0.4, Q3<=30, P3*0.3, Q3>30, P3*0.2)
        if (params.data.imp_variants == 0)
          return (params.data.imp_estimatedSales * 1).toFixed(2);
        if (params.data.imp_variants <= 2)
          return (params.data.imp_estimatedSales * 0.8).toFixed(2);
        if (params.data.imp_variants <= 5)
          return (params.data.imp_estimatedSales * 0.7).toFixed(2);
        if (params.data.imp_variants <= 8)
          return (params.data.imp_estimatedSales * 0.6).toFixed(2);
        if (params.data.imp_variants <= 12)
          return (params.data.imp_estimatedSales * 0.55).toFixed(2);
        if (params.data.imp_variants <= 15)
          return (params.data.imp_estimatedSales * 0.5).toFixed(2);
        if (params.data.imp_variants <= 19)
          return (params.data.imp_estimatedSales * 0.45).toFixed(2);
        if (params.data.imp_variants <= 25)
          return (params.data.imp_estimatedSales * 0.4).toFixed(2);
        if (params.data.imp_variants <= 30)
          return (params.data.imp_estimatedSales * 0.3).toFixed(2);
        if (params.data.imp_variants > 30)
          return (params.data.imp_estimatedSales * 0.2).toFixed(2);
      },*/
    },
    {
      headerName: "Stripe Surcharge (3.5%)",
      field: "imp_stripeSurcharge",
      /*valueGetter: (params) => {
        return (
          params.data.imp_packQuantity * params.data.imp_vendorCost * 0.035
        );
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      headerTooltip: "Pack Cost * 0.035",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
    },
    {
      headerName: "Ship To Warehouse",
      field: "imp_shipToWarehouse",
      headerTooltip:
        "IF(AND(Package Weight>0, Package Weight<=8), 1.5, IF(AND(Package Weight>8, Package Weight<=16), 3.1, IF(AND(Package Weight>16, Package Weight<=24), 4.65, IF(AND(Package Weight>24, Package Weight<=32), 6.2, 0))))",
      /*valueGetter: (params) => {
        return getShipToWarehouse(params);
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      editable: true,
      valueSetter: saveNewValue,
    },
    {
      headerName: "Ship To Amazon",
      field: "imp_shipToAmazon",
      headerTooltip:
        "IF(AND(FBA/FBM = 'FBA', Fullfilment Subtotal < 10, Fullfilment Subtotal > 0), 2, IF(AND(FBA/FBM = 'FBA', Fullfilment Subtotal >= 10, Fullfilment Subtotal < 20), 3, IF(AND(FBA/FBM = 'FBA', Fullfilment Subtotal >= 20, Fullfilment Subtotal < 30), 4, IF(AND(FBA/FBM = 'FBA', Fullfilment Subtotal >= 30, Fullfilment Subtotal < 40), 5, IF(AND(FBA/FBM = 'FBA', Fullfilment Subtotal >= 40, Fullfilment Subtotal < 50), 6, IF(AND(FBA/FBM = 'FBA', Fullfilment Subtotal >= 50), 8, 0))))))",
      /*valueGetter: (params) => {
        return getShipToAmazon(params);
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Ship To Customer",
      field: "imp_shipToCustomer",
      headerTooltip:
        "IF(AND(FBA/FBM='FBM',imp_packageWeight>0,imp_packageWeight<=1),5.96, IF(AND(FBA/FBM='FBM',imp_packageWeight>1,imp_packageWeight<=2),7.64, IF(AND(FBA/FBM='FBM',imp_packageWeight>2,imp_packageWeight<=3),8.86, IF(AND(FBA/FBM='FBM',imp_packageWeight>3,imp_packageWeight<=4),9.69, IF(AND(FBA/FBM='FBM',imp_packageWeight>4,imp_packageWeight<=5),10.13, IF(AND(FBA/FBM='FBM',imp_packageWeight>5,imp_packageWeight<=6),10.34, IF(AND(FBA/FBM='FBM',imp_packageWeight>6,imp_packageWeight<=7),10.64, IF(AND(FBA/FBM='FBM',imp_packageWeight>7,imp_packageWeight<=8),10.69, IF(AND(FBA/FBM='FBM',imp_packageWeight>8,imp_packageWeight<=9),10.78, IF(AND(FBA/FBM='FBM',imp_packageWeight>9,imp_packageWeight<=10),11.74, IF(AND(FBA/FBM='FBM',imp_packageWeight>10,imp_packageWeight<=21),11.79,0)))))))))))",
      /*valueGetter: (params) => {
        return getShipToCustomer(params);
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Net Profit",
      field: "imp_netProfit",
      headerTooltip:
        "If(profit not equal to 0(zero)){ profit - (stripe surcharge + ship to warehouse + ship to amazon + ship to customer + fba/fbm prep)} else ''",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      cellClassRules: cellNetProfitRules,
      /*valueGetter: (params) => {
        const packCost =
          params.data.imp_packQuantity * params.data.imp_vendorCost;

        const profit =
          params.data.imp_sellPrice -
          (params.data.imp_referralFee +
            params.data.imp_InboundPlac +
            params.data.imp_fulfillmentSubtotal +
            packCost);
        const stripeSurcharge =
          params.data.imp_packQuantity * params.data.imp_vendorCost * 0.035;
        return profit != 0
          ? profit -
              stripeSurcharge -
              getShipToWarehouse(params) -
              getShipToAmazon(params) -
              getShipToCustomer(params) -
              params.data.imp_FBAFBMPrep
          : 0;
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },
    {
      headerName: "Net Profit Margin",
      field: "imp_netProfitMargin",
      headerStyle: { "background-color": "#90EE90" },
      valueFormatter: (params) => params.value.toFixed(2) + "%",
    },
    {
      headerName: "Previously listed",
      field: "imp_currentlyInBC",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      /*valueGetter: (params) => {
        return params.data.imp_currentlyInBC ? "YES" : "NO";
      },*/
    },
    {
      headerName: "Pack Cost",
      field: "imp_packCost",
      headerTooltip: "Pack Qty * Vendor Cost",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      /* valueGetter: (params) => {
        return params.data.imp_packQuantity * params.data.imp_vendorCost;
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },
    {
      headerName: "Can't be sold on",
      field: "imp_restrictedChannels",
      editable: true,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      cellEditor: "agRichSelectCellEditor",
      cellEditorParams: {
        values: ["None", "Amazon", "Walmart", "Amazon and Walmart"],
      },
      valueGetter: (params) => {
        switch (params.data.imp_restrictedChannels) {
          case 0:
            return "";
          case 1:
            return "Amazon";
          case 2:
            return "Walmart";
          case 3:
            return "Amazon and Walmart";
          default:
            return "";
        }
      },
    },
    {
      headerName: "FBA",
      field: "imp_FBA",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      editable: true,
      valueSetter: saveNewValue,
    },
    {
      headerName: "FBM",
      field: "imp_FBM",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      editable: true,
      valueSetter: saveNewValue,
    },
    {
      headerName: "eBay",
      field: "imp_ebay",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      editable: true,
      valueSetter: saveNewValue,
    },
    {
      headerName: "Walmart",
      field: "imp_walmart",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      editable: true,
      valueSetter: saveNewValue,
    },
    {
      headerName: "Other",
      field: "imp_any",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      editable: true,
      valueSetter: saveNewValue,
    },
    {
      headerName: "Online Store",
      field: "imp_onlineStore",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      editable: true,
      valueSetter: saveNewValue,
    },
    {
      headerName: "Liquidations",
      field: "imp_liquidations",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      editable: true,
      valueSetter: saveNewValue,
    },
    {
      headerName: "FBA/FBM Prep.",
      field: "imp_FBAFBMPrep",
      editable: true,
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
    },
    {
      headerName: "At Sell Price",
      field: "imp_ATSellPrice",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      editable: true,
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },
    {
      headerName: "Enter Current Prime Sell Price",
      field: "imp_currentPrimeSellPrice",
      editable: true,
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },
    {
      headerName: "AVG eBay Price",
      field: "imp_currentEbaySellPrice",
      editable: true,
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
    },
    {
      headerName: "Selling Price +/-",
      field: "imp_sellingPriceVariation",
      headerTooltip: "Enter Current Prime Sell Price - AT Sell Price",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      cellClassRules: cellSellingPriceRules,
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      /*valueGetter: (params) => {
        return params.data.imp_currentPrimeSellPrice == null
          ? 0
          : params.data.imp_currentPrimeSellPrice - params.data.imp_sellPrice;
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },
    {
      headerName: "90 Day AMZ BuyBox Avg",
      field: "imp_90DaysAvgBuyBox",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Approval To List Code",
      field: "imp_approvalToListCode",
      minWidth: 180,
      editable: true,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
      cellDataType: "text",
      cellEditor: "agRichSelectCellEditor",
      cellRenderer: ColourCellRenderer,
      cellEditorParams: {
        cellRenderer: ColourCellRenderer,
        values: [
          "1-Open To List",
          "2-Click and Approved",
          "3-Brand Application",
          "4-Invoice Required",
          "5-eBay",
          "6-walmart",
          "7-Other",
          "99-Do Not List",
        ],
      },
      valueGetter: (params) => {
        switch (params.data.imp_approvalToListCode) {
          case 1:
            return "1-Open To List";
          case 2:
            return "2-Click and Approved";
          case 3:
            return "3-Brand Application";
          case 4:
            return "4-Invoice Required";
          case 5:
            return "5-eBay";
          case 6:
            return "6-walmart";
          case 7:
            return "7-Other";
          case 99:
            return "99-Do Not List";
          default:
            return "";
        }
      },
    },

    {
      headerName: "Package Dimensions (max. L >= 25ins)",
      field: "imp_packageDimensions",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Package Weight (max. 20lbs)",
      field: "imp_packageWeight",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      valueFormatter: (params) =>
        params.value ? params.value.toFixed(2) : "0.00",
    },
    {
      headerName: "Profit",
      field: "imp_profit",
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
      headerTooltip:
        "sell price - (referral fee + inbound placement fee + fullfillment subtotal)",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      /*valueGetter: (params) => {
        return (
          params.data.imp_sellPrice -
          (params.data.imp_referralFee +
            params.data.imp_InboundPlac +
            params.data.imp_fulfillmentSubtotal +
            params.data.imp_packCost)
        );
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },
    {
      headerName: "Margin",
      field: "imp_margin",
      headerTooltip:
        "If(profit not equal to 0(zero)){ profit - sell price)} else ''",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      /*valueGetter: (params) => {
        const packCost =
          params.data.imp_packQuantity * params.data.imp_vendorCost;

        const profit =
          params.data.imp_sellPrice -
          (params.data.imp_referralFee +
            params.data.imp_InboundPlac +
            params.data.imp_fulfillmentSubtotal +
            packCost);
        return profit != 0 ? profit / params.data.imp_sellPrice : 0;
      },*/
      valueFormatter: (params) =>
        params.value ? params.value.toFixed(2) + " %" : "0 %",
    },
    {
      headerName: "ROI",
      field: "imp_ROI",
      editable: false,
      headerTooltip: "If(profit not equal to 0(zero)) profit / pack cost",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      /*valueGetter: (params) => {
        const packCost =
          params.data.imp_packQuantity * params.data.imp_vendorCost;

        const profit =
          params.data.imp_sellPrice -
          (params.data.imp_referralFee +
            params.data.imp_InboundPlac +
            params.data.imp_fulfillmentSubtotal +
            packCost);

        const roi = profit != 0 ? profit / packCost : 0;
        return roi * 100;
      },*/
      valueFormatter: (params) =>
        params.value ? params.value.toFixed(2) + " %" : "0 %",
    },
    {
      headerName: "FBA/FBM Prep.",
      field: "imp_FBAFBMPrep",
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#FFF2CC" },
      cellClass: "age-border",
    },
    {
      headerName: "Lead Time",
      field: "imp_leadTime",
      editable: true,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "MAP",
      field: "imp_MAP",
      editable: true,
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "Vendor",
      field: "imp_ven_name",
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "MOV",
      field: "imp_MOV",
      editable: true,
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "MOQ",
      field: "imp_MOQ",
      editable: true,
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "Case Qty.",
      field: "imp_caseQuantity",
      editable: true,
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "Confirmed Stock",
      field: "imp_confirmedStock",
      editable: true,
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "# Of Sales / month",
      field: "imp_newEstimatedSales",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
    },
    {
      headerName: "Max PACKS we should buy per 4 month sellout",
      field: "imp_maxPWSBP4MS",
      headerTooltip: "# of sales * max months to sell out",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      headerStyle: { "background-color": "#FFFF00" },
      cellClass: "age-border",
      /*valueGetter: (params) => {
        const saleMonth =
          params.data.imp_variants == 0
            ? 1 * params.data.imp_packQuantity
            : params.data.imp_variants <= 2
            ? 0.8 * params.data.imp_packQuantity
            : params.data.imp_variants <= 5
            ? 0.7 * params.data.imp_packQuantity
            : params.data.imp_variants <= 8
            ? 0.6 * params.data.imp_packQuantity
            : params.data.imp_variants <= 12
            ? 0.55 * params.data.imp_packQuantity
            : params.data.imp_variants <= 15
            ? 0.5 * params.data.imp_packQuantity
            : params.data.imp_variants <= 19
            ? 0.45 * params.data.imp_packQuantity
            : params.data.imp_variants <= 25
            ? 0.4 * params.data.imp_packQuantity
            : params.data.imp_variants <= 30
            ? 0.3 * params.data.imp_packQuantity
            : params.data.imp_variants > 30
            ? 0.2 * params.data.imp_packQuantity
            : 0;
        return saleMonth * params.data.imp_maxMTSO;
      },*/
      // valueFormatter: (params) => params.value.toFixed(2),
    },
    {
      headerName: "Max UNITS we should buy per 4 month sellout",
      headerTooltip:
        "Max PACKS we should buy per 4 month sellout * Pack quantity",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      field: "imp_maxUWSBP4MS",
      headerStyle: { "background-color": "#FFFF00" },
      cellClass: "age-border",
      /*valueGetter: (params) => {
        const saleMonth =
          params.data.imp_variants == 0
            ? 1 * params.data.imp_packQuantity
            : params.data.imp_variants <= 2
            ? 0.8 * params.data.imp_packQuantity
            : params.data.imp_variants <= 5
            ? 0.7 * params.data.imp_packQuantity
            : params.data.imp_variants <= 8
            ? 0.6 * params.data.imp_packQuantity
            : params.data.imp_variants <= 12
            ? 0.55 * params.data.imp_packQuantity
            : params.data.imp_variants <= 15
            ? 0.5 * params.data.imp_packQuantity
            : params.data.imp_variants <= 19
            ? 0.45 * params.data.imp_packQuantity
            : params.data.imp_variants <= 25
            ? 0.4 * params.data.imp_packQuantity
            : params.data.imp_variants <= 30
            ? 0.3 * params.data.imp_packQuantity
            : params.data.imp_variants > 30
            ? 0.2 * params.data.imp_packQuantity
            : 0;
        return (
          saleMonth * params.data.imp_maxMTSO * params.data.imp_packQuantity
        );
      },*/
    },
    {
      headerName: "How many we buy (rounded down)",
      field: "imp_howManyWeBuy",
      editable: true,
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      headerTooltip:
        "IF(MOQ > 0) {MOQ} else {IF(Confirmed Stock != 0){Confirmed Stock *0.5} else {''}",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      /*valueGetter: (params) => {
        if (params.data.imp_MOQ > 0) {
          return params.data.imp_MOQ;
        } else if (params.data.imp_confirmedStock != 0) {
          return params.data.imp_confirmedStock * 0.5;
        } else {
          return "";
        }
      },*/
    },
    {
      headerName: "Max Months To Sell Out",
      field: "imp_maxMTSO",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      editable: true,
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
    },
    {
      headerName: "Velocity limiter (Step 1)",
      field: "imp_velocityLimiter",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      headerTooltip: "how many we buy (rounded down) / max months to sell out",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      /*valueGetter: (params) => {
        const howManyBuy =
          params.data.imp_MOQ > 0
            ? params.data.imp_MOQ
            : params.data.imp_confirmedStock != 0
            ? params.data.imp_confirmedStock * 0.5
            : 0;

        return howManyBuy / params.data.imp_maxMTSO;
      },*/
    },
    {
      headerName: "# of existing sellers",
      field: "imp_numExistingSellers",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      headerTooltip:
        "IF(FBA == 1) {new FBA offer} else if(FBM ==0) {new FBM offer} else {''}",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      /*valueGetter: (params) => {
        if (params.data.imp_FBA) {
          return params.data.imp_newFBAOffers;
        } else if (!params.data.imp_FBM) {
          return params.data.imp_newFBMOffers;
        } else return params.data.imp_numExistingSellers;
      },*/
    },
    {
      headerName: "Total # of all sellers theroretically (Step 2)",
      field: "imp_totalNOASTS2",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      headerTooltip: "# of Sales / velocty limiter (Step 1) ",
      /*valueGetter: (params) => {
        const saleMonth =
          params.data.imp_variants == 0
            ? 1 * params.data.imp_packQuantity
            : params.data.imp_variants <= 2
            ? 0.8 * params.data.imp_packQuantity
            : params.data.imp_variants <= 5
            ? 0.7 * params.data.imp_packQuantity
            : params.data.imp_variants <= 8
            ? 0.6 * params.data.imp_packQuantity
            : params.data.imp_variants <= 12
            ? 0.55 * params.data.imp_packQuantity
            : params.data.imp_variants <= 15
            ? 0.5 * params.data.imp_packQuantity
            : params.data.imp_variants <= 19
            ? 0.45 * params.data.imp_packQuantity
            : params.data.imp_variants <= 25
            ? 0.4 * params.data.imp_packQuantity
            : params.data.imp_variants <= 30
            ? 0.3 * params.data.imp_packQuantity
            : params.data.imp_variants > 30
            ? 0.2 * params.data.imp_packQuantity
            : 0;

        const howManyBuy =
          params.data.imp_MOQ > 0
            ? params.data.imp_MOQ
            : params.data.imp_confirmedStock != 0
            ? params.data.imp_confirmedStock * 0.5
            : 0;

        const vl = howManyBuy / params.data.imp_maxMTSO;
        if (vl == 0) return 0;
        return params.data.imp_estimatedSales / vl;
      },*/
      valueFormatter: (params) => params.value.toFixed(2),
    },
    {
      headerName: "# of new BC members (manually round up/down Max 7) (Step 3)",
      field: "imp_numONBCM",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      editable: true,
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
    },
    {
      headerName: "# of products per member",
      field: "imp_numOPPM",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      headerTooltip: "How Many We Buy / # of new BC members",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      /*valueGetter: (params) => {
        const howManyBuy =
          params.data.imp_MOQ > 0
            ? params.data.imp_MOQ
            : params.data.imp_confirmedStock != 0
            ? params.data.imp_confirmedStock * 0.5
            : 0;
        return params.data.imp_numONBCM == 0
          ? 0
          : howManyBuy / params.data.imp_numONBCM;
      },*/
    },
    {
      headerName: "# Prods/Packs/Member (round down)",
      field: "imp_numPPM",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      headerTooltip: "# Products per member / pack quantity",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      /*valueGetter: (params) => {
        const howManyBuy =
          params.data.imp_MOQ > 0
            ? params.data.imp_MOQ
            : params.data.imp_confirmedStock != 0
            ? params.data.imp_confirmedStock * 0.5
            : 0;
        const prodPerMember =
          params.data.imp_numONBCM == 0
            ? 0
            : howManyBuy / params.data.imp_numONBCM;

        return params.data.imp_packQuantity == 0
          ? 0
          : prodPerMember / params.data.imp_packQuantity;
      },*/
    },
    {
      headerName: "Per Member Purchase Price",
      field: "imp_perMPP",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      headerTooltip: "Pack Cost * # Prods/Packs/Member",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      /* valueGetter: (params) => {
        const howManyBuy =
          params.data.imp_MOQ > 0
            ? params.data.imp_MOQ
            : params.data.imp_confirmedStock != 0
            ? params.data.imp_confirmedStock * 0.5
            : 0;
        const prodPerMember =
          params.data.imp_numONBCM == 0
            ? 0
            : howManyBuy / params.data.imp_numONBCM;

        const ppm =
          params.data.imp_packQuantity == 0
            ? 0
            : prodPerMember / params.data.imp_packQuantity;
        const packCost =
          params.data.imp_packQuantity * params.data.imp_vendorCost;
        return packCost * ppm;
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },

    {
      headerName: "Prods/Packs we buy total",
      field: "imp_PPWBT",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      headerTooltip: "# of BC members * # Prods/Packs/Member",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      /*valueGetter: (params) => {
        const howManyBuy =
          params.data.imp_MOQ > 0
            ? params.data.imp_MOQ
            : params.data.imp_confirmedStock != 0
            ? params.data.imp_confirmedStock * 0.5
            : 0;
        const prodPerMember =
          params.data.imp_numONBCM == 0
            ? 0
            : howManyBuy / params.data.imp_numONBCM;

        const ppm =
          params.data.imp_packQuantity == 0
            ? 0
            : prodPerMember / params.data.imp_packQuantity;
        return params.data.imp_numONBCM * ppm;
      },*/
    },
    {
      headerName: "Total order value",
      field: "imp_totalOrderValue",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      headerTooltip: "# of new BC members * per member purchase price",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      /*valueGetter: (params) => {
        const howManyBuy =
          params.data.imp_MOQ > 0
            ? params.data.imp_MOQ
            : params.data.imp_confirmedStock != 0
            ? params.data.imp_confirmedStock * 0.5
            : 0;
        const prodPerMember =
          params.data.imp_numONBCM == 0
            ? 0
            : howManyBuy / params.data.imp_numONBCM;

        const ppm =
          params.data.imp_packQuantity == 0
            ? 0
            : prodPerMember / params.data.imp_packQuantity;
        const packCost =
          params.data.imp_packQuantity * params.data.imp_vendorCost;
        const pmpp = packCost * ppm;

        return params.data.imp_numONBCM * pmpp;
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },
    {
      headerName: "Units Per Pack",
      field: "imp_packQuantity",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
    },
    {
      headerName: "Per Member Order Weight",
      field: "imp_PMOW",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      headerTooltip: "Package Weight * # Prods/Packs/Member",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      /*valueGetter: (params) => {
        const howManyBuy =
          params.data.imp_MOQ > 0
            ? params.data.imp_MOQ
            : params.data.imp_confirmedStock != 0
            ? params.data.imp_confirmedStock * 0.5
            : 0;
        const prodPerMember =
          params.data.imp_numONBCM == 0
            ? 0
            : howManyBuy / params.data.imp_numONBCM;

        const ppm =
          params.data.imp_packQuantity == 0
            ? 0
            : prodPerMember / params.data.imp_packQuantity;
        return params.data.imp_packageWeight * ppm;
      },*/
      valueFormatter: (params) => params.value.toFixed(2),
    },
    {
      headerName: "Mark Up",
      field: "imp_markupPercentage",
      headerStyle: { "background-color": "#D9D2E9" },
      cellClass: "age-border",
      editable: true,
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => params.value + " %",
    },
    {
      headerName: "ORDER NOTES",
      field: "imp_orderNotes",
      editable: true,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#FFF" },
      cellClass: "age-border",
    },
    {
      headerName: "STOCK NOTES",
      field: "imp_stockNotes",
      headerStyle: { "background-color": "#FFF" },
      cellClass: "age-border",
    },
    {
      headerName: "ANALISYS NOTES",
      field: "imp_notes",
      headerStyle: { "background-color": "#FFF" },
      cellClass: "age-border",
    },
    {
      headerName: "Rejection Reason",
      field: "imp_rejectionReason",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
  ]);

  const currencyFormatter = (currency) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(currency);
  };

  useEffect(() => {
    if (!suppliers || suppliers.length === 0) {
      const data = {
        page: 0,
        total_rows: 1000,
        sort_by: "sup_name",
      };
      dispatch(onGetSuppliers(data));
    }
  }, []);

  useEffect(() => {
    setRowData(imports);
  }, [imports]);

  useEffect(() => {
    if (updatedStatus) {
      getImports();
    }
  }, [updatedStatus]);

  useEffect(() => {
    if (suppliers) {
      setSuppliersList(
        suppliers.map((item) => ({ label: item.sup_name, value: item.sup_id }))
      );
    }
  }, [suppliers]);

  /*
  useEffect(() => {    
    if (gridApi && rowData.length > 0) gridApi.sizeColumnsToFit({
      defaultMinWidth: 130,
    });
  }, [rowData]);
*/
  const autoSizeStrategy = useMemo(() => {
    return {
      type: "fitGridWidth",
      defaultMinWidth: 100,
    };
  }, []);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
      setDate(defaultdate());
    }
  }, [modal]);

  const defaultdate = () => {
    let d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    let h = d.getHours() % 12 || 12;
    let ampm = d.getHours() < 12 ? "AM" : "PM";
    return (
      d.getDate() +
      " " +
      months[d.getMonth()] +
      ", " +
      d.getFullYear() +
      ", " +
      h +
      ":" +
      d.getMinutes() +
      " " +
      ampm
    ).toString();
  };

  const [date, setDate] = useState(defaultdate());

  const dateformate = (e) => {
    const dateString = e.toString().split(" ");

    let time = dateString[4];
    let H = +time.substr(0, 2);
    let h = H % 12 || 12;
    h = h <= 9 ? (h = "0" + h) : h;
    let ampm = H < 12 ? "AM" : "PM";
    time = h + time.substr(2, 3) + " " + ampm;

    const date = dateString[2] + " " + dateString[1] + ", " + dateString[3];
    const orderDate = (date + ", " + time).toString();
    setDate(orderDate);
  };

  const handleValidDate = (date) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  function handleAnalysisStatus(status) {
    setSelectedAnalysisStatus(status);
  }

  function handleChangeSuplier(orderPayement) {
    setSupplier(orderPayement);
  }

  const onCellEditingStopped = (event) => {
    const row = event.data;
    let newRow;
    // Avoid unnecessary updates when value didn't change
    if (event.newValue === event.oldValue) {
      return false;
    }
    switch (event.column.colId) {
      case "imp_currentPrimeSellPrice":
        newRow = { ...row, imp_currentPrimeSellPrice: event.newValue };
        break;
      case "imp_approvalToListCode":
        let code;
        switch (event.newValue) {
          case "1-Open To List":
            code = 1;
            break;
          case "2-Click and Approved":
            code = 2;
            break;
          case "3-Brand Application":
            code = 3;
            break;
          case "4-Invoice Required":
            code = 4;
            break;
          case "5-eBay":
            code = 5;
            break;
          case "6-walmart":
            code = 6;
            break;
          case "7-Other":
            code = 7;
            break;
          case "99-Do Not List":
            code = 99;
            break;
          default:
            code = 0;
        }
        newRow = { ...row, imp_approvalToListCode: code };
        break;
      case "imp_restrictedChannels":
        let value;
        switch (event.newValue) {
          case "Amazon":
            value = 1;
            break;
          case "Walmart":
            value = 2;
            break;
          case "Amazon and Walmart":
            value = 3;
            break;
          default:
            value = 0;
            break;
        }
        newRow = { ...row, imp_restrictedChannels: value };
        break;
      case "imp_orderNotes":
        newRow = { ...row, imp_orderNotes: event.newValue };
        break;
      case "imp_packQuantity":
        newRow = { ...row, imp_packQuantity: event.newValue };
        break;
      case "imp_vendorCost":
        newRow = { ...row, imp_vendorCost: event.newValue };
        break;
      case "imp_amazonSeller":
        newRow = { ...row, imp_amazonSeller: event.newValue };
        break;
      case "imp_FBA":
        newRow = { ...row, imp_FBA: event.newValue };
        break;
      case "imp_FBM":
        newRow = { ...row, imp_FBM: event.newValue };
        break;
      case "imp_ebay":
        newRow = { ...row, imp_ebay: event.newValue };
        break;
      case "imp_walmart":
        newRow = { ...row, imp_walmart: event.newValue };
        break;
      case "imp_any":
        newRow = { ...row, imp_any: event.newValue };
        break;
      case "imp_onlineStore":
        newRow = { ...row, imp_onlineStore: event.newValue };
        break;
      case "imp_liquidations":
        newRow = { ...row, imp_liquidations: event.newValue };
        break;
      case "imp_FBAFBMPrep":
        newRow = { ...row, imp_FBAFBMPrep: event.newValue };
        break;
      case "imp_ATSellPrice":
        newRow = { ...row, imp_ATSellPrice: event.newValue };
        break;
      case "imp_currentEbaySellPrice":
        newRow = { ...row, imp_currentEbaySellPrice: event.newValue };
        break;
      case "imp_maxMTSO":
        newRow = { ...row, imp_maxMTSO: event.newValue };
        break;
      case "imp_numONBCM":
        newRow = { ...row, imp_numONBCM: event.newValue };
        break;
      case "imp_leadTime":
        newRow = { ...row, imp_leadTime: event.newValue };
        break;
      case "imp_MAP":
        newRow = { ...row, imp_MAP: event.newValue };
        break;
      case "imp_MOV":
        newRow = { ...row, imp_MOV: event.newValue };
        break;
      case "imp_MOQ":
        newRow = { ...row, imp_MOQ: event.newValue };
        break;
      case "imp_confirmedStock":
        newRow = { ...row, imp_confirmedStock: event.newValue };
        break;
      case "imp_markupPercentage":
        newRow = { ...row, imp_markupPercentage: event.newValue };
        break;
      case "imp_howManyWeBuy":
        newRow = { ...row, imp_howManyWeBuy: event.newValue };
        break;
      case "imp_sellPrice":
        newRow = { ...row, imp_sellPrice: event.newValue };
        break;
      case "imp_shipToWarehouse":
        newRow = { ...row, imp_shipToWarehouse: event.newValue };
        break;
      case "imp_estimatedSales": {
        const next = Number.parseInt(event.newValue, 10) || 0;
        if (next === row.imp_estimatedSales) return false;
        newRow = { ...row, imp_estimatedSales: next };
        break;
      }
      case "imp_title":
        newRow = { ...row, imp_title: event.newValue };
        break;
      case "imp_brand":
        newRow = { ...row, imp_brand: event.newValue };
        break;
      default:
        newRow = { ...row };
    }
    dispatch(onUpdateRow(JSON.stringify(newRow)));
    const newData = [...rowData];
    const index = newData.findIndex((item) => item.imp_id === newRow.imp_id);
    newData[index] = newRow;
    setRowData(newData);
    return false;
  };

  const onGridReady = (params) => {
    getImports();
  };

  const onSelectionChanged = () => {
    const selectedData = gridApi.current.api.getSelectedRows();
    setSelectedRows(selectedData);
  };

  const handleUpdateStatus = async (statusData) => {
    try {
      const resultAction = await dispatch(onUpdateStatus(statusData));
      if (resultAction.payload?.success) {
        const result = resultAction.payload.data;
        
        // Show appropriate toast based on status
        if (result.status === "Success") {
          toast.success(result.summaryMessage || "Status updated successfully", {
            position: "top-center",
            autoClose: 2000,
          });
        } else if (result.status === "Parcial") {
          toast.warning(result.summaryMessage || "Status updated with some errors", {
            position: "top-center",
            autoClose: 3000,
          });
        } else if (result.status === "Failed") {
          toast.error(result.summaryMessage || "Failed to update status", {
            position: "top-center",
            autoClose: 3000,
          });
        }
        
        // Show detailed modal only for partial success or failures
        if (result.status === "Parcial" || result.status === "Failed") {
          setUpdateResult(result);
          setResultModal(true);
        }
      }
    } catch (error) {
      console.error("Update status error:", error);
    }
  };

  const handleRejectProduct = (reason) => {
    handleUpdateStatus({
      imp_ids: selectedRows.map((item) => item.imp_id),
      imp_status: productsStatus.STATUS_REJECTED_FINAL,
      imp_rejectionReason: reason,
    });
    setModal(false);
  };

  const handleRestrictProduct = (channels) => {
    const newData = [...rowData];
    selectedRows.map((item) => {
      const newRow = { ...item, imp_restrictedChannels: Number(channels) };
      dispatch(onUpdateRow(JSON.stringify(newRow)));
      const index = newData.findIndex((item) => item.imp_id === newRow.imp_id);
      newData[index] = newRow;
    });
    setRowData(newData);
    setShowRestrictChannels(false);
  };

  const onBtExport = () => {
    const analysisStatusLabels = selectedAnalysisStatus
      .map((status) => status.label)
      .join("_");

    gridApi.current.api.exportDataAsExcel({
      fileName:
        "FinalAnalysis_" +
        moment(dateFrom).format("YYYYMMDD") +
        "_" +
        moment(dateTo).format("YYYYMMDD") +
        "_" +
        analysisStatusLabels +
        (supplier.length > 0
          ? "_" +
            suppliersList
              .filter((s) => supplier.some((sup) => sup.value === s.value))
              .map((s) => s.label)
              .join("_")
          : "") +
        ".xlsx",
    });
  };

  document.title = "Final Analysis | Buyers Club";
  return (
    <div className="page-content">
      <RejectModal
        show={modal}
        type="final"
        onRejectClick={(reason) => handleRejectProduct(reason)}
        onCloseClick={() => setModal(false)}
      />
      <StatusUpdateResultModal
        show={resultModal}
        result={updateResult}
        onCloseClick={() => {
          setResultModal(false);
          setUpdateResult(null);
        }}
      />
      <RestrictChannelsModal
        show={showRestrictChannels}
        onRestrictClick={(reason) => handleRestrictProduct(reason)}
        onCloseClick={() => setShowRestrictChannels(false)}
      />
      <Container fluid>
        <BreadCrumb title="Final Analysis" pageTitle="Analysis" />
        <Row>
          <Col lg={12}>
            <Card id="refreshesList">
              <CardHeader className="border-0">
                <Row className="align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Final Analysis</h5>
                  </div>
                </Row>
              </CardHeader>

              <CardBody className="pt-0">
                <Card className=" p-2">
                  <CardTitle className="mb-2">
                    <h5 className="card-title mb-0">Filters</h5>
                  </CardTitle>
                  <Row className="mb-2">
                    <Col xs={12} sm={12} xl={3} className="d-flex gap-3 mb-2">
                      <div>
                        <label htmlFor="analysisDate" className="form-label">
                          Date From
                        </label>
                        <Flatpickr
                          className="form-control"
                          id="datepicker-publish-input"
                          placeholder="Select a date from"
                          onChange={(selectedDates, dateStr, instance) => {
                            setDateFrom(selectedDates[0]);
                          }}
                          options={{
                            defaultDate: moment(dateFrom).format("MM-DD-YYYY"),
                            mode: "single",
                            dateFormat: "m-d-Y",
                          }}
                        />
                      </div>

                      <div>
                        <label htmlFor="analysisDate" className="form-label">
                          Date To
                        </label>
                        <Flatpickr
                          className="form-control"
                          id="datepicker-publish-input"
                          label="To"
                          placeholder="Select a date to"
                          onChange={(selectedDates, dateStr, instance) => {
                            setDateTo(selectedDates[0]);
                          }}
                          options={{
                            defaultDate: moment(dateTo).format("MM-DD-YYYY"),
                            mode: "single",
                            dateFormat: "m-d-Y",
                          }}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={3}>
                      <label htmlFor="analysisStatus" className="form-label">
                        Analysis Status
                      </label>
                      <Select
                        autoFocus
                        label="Select Analysis Status"
                        placeholder="Select Status"
                        value={selectedAnalysisStatus}
                        onChange={(e) => {
                          handleAnalysisStatus(e);
                        }}
                        options={analysisStatus}
                        isMulti
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={3}>
                      <label htmlFor="supplier" className="form-label">
                        Supplier
                      </label>
                      <Select
                        placeholder="Select Supplier"
                        value={supplier}
                        onChange={(e) => {
                          setSupplier(e);
                        }}
                        options={suppliersList}
                        isMulti
                      />
                    </Col>

                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div>
                        <button
                          type="button"
                          className="btn btn-primary  mt-2"
                          onClick={() => getImports()}
                        >
                          {" "}
                          <i className="ri-equalizer-fill me-1 align-bottom"></i>
                          Filter
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Card>
                <div className="d-flex gap-1 m-2">
                  <div className="d-flex gap-1 align-items-center">
                    <h4 className="text-muted">Total</h4>
                    <h4 className="text-muted">:</h4>
                    <h4 className="text-muted">{imports.length}</h4>
                    <h4 className="text-muted">|</h4>
                    <h4 className="text-muted">Selected</h4>
                    <h4 className="text-muted">:</h4>
                    <h4 className="text-muted">
                      {selectedRows.length > 0 ? selectedRows.length : 0}
                    </h4>
                  </div>
                  <div
                    className="d-flex gap-1 justify-content-end"
                    style={{ width: "100%" }}
                  >
                    <button
                      disabled={updatingStatus || selectedRows.length === 0}
                      type="button"
                      className="btn btn-info"
                      onClick={() =>
                        selectedRows.length > 0
                          ? handleUpdateStatus({
                              imp_ids: selectedRows.map(
                                (item) => item.imp_id
                              ),
                              imp_status:
                                productsStatus.STATUS_READYFORPUBLISH,
                            })
                          : toast.error("Please select a product")
                      }
                    >
                      {updatingStatus && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                      Ready for Catalog
                    </button>
                    <button
                      disabled={updatingStatus || selectedRows.length === 0}
                      type="button"
                      className="btn btn-danger"
                      onClick={() =>
                        selectedRows.length > 0
                          ? handleUpdateStatus({
                              imp_ids: selectedRows.map(
                                (item) => item.imp_id
                              ),
                              imp_status: productsStatus.STATUS_READYFORSTOCK,
                            })
                          : toast.error("Please select a product")
                      }
                    >
                      {updatingStatus && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                      Back to Stock Check
                    </button>
                    <button
                      disabled={updatingStatus || selectedRows.length === 0}
                      type="button"
                      className="btn btn-danger"
                      onClick={() =>
                        selectedRows.length > 0
                          ? setShowRestrictChannels(true)
                          : toast.error(
                              "Please choose at least one product to proceed"
                            )
                      }
                    >
                      <i className="ri-prohibited-line"></i>
                      Restrict Channels
                    </button>
                    <button
                      disabled={updatingStatus || selectedRows.length === 0}
                      type="button"
                      className="btn btn-warning"
                      onClick={() =>
                        selectedRows.length > 0
                          ? setModal(true)
                          : toast.error(
                              "Please choose at least one product to proceed"
                            )
                      }
                    >
                      <i className="ri-prohibited-line"></i>
                      Reject Product
                    </button>
                    <button
                      disabled={updatingStatus || selectedRows.length === 0}
                      type="button"
                      className="btn btn-success"
                      onClick={() =>
                        selectedRows.length > 0
                          ? handleUpdateStatus({
                              imp_ids: selectedRows.map(
                                (item) => item.imp_id
                              ),
                              imp_status: productsStatus.STATUS_READYFORFINAL,
                            })
                          : toast.error("Please select a product")
                      }
                    >
                      {updatingStatus && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                      <i className="ri-check-line"></i>
                      Un-Reject Product
                    </button>
                    <button
                      disabled={imports.length === 0}
                      type="button"
                      className="btn btn-secondary"
                      onClick={onBtExport}
                    >
                      <i className="ri-file-download-line"></i>
                      Export
                    </button>
                  </div>
                </div>
                <div style={{ height: "70vh", width: "100%" }}>
                  <AgGridReact
                    ref={gridApi}
                    onGridReady={onGridReady}
                    rowData={rowData}
                    defaultColDef={defaultColDef}
                    columnDefs={colDefs}
                    rowSelection={rowSelection}
                    maintainColumnOrder={true}
                    onCellEditingStopped={onCellEditingStopped}
                    suppressScrollOnNewData={true}
                    onSelectionChanged={onSelectionChanged}
                    cellSelection={true}
                    excelStyles={excelStyles}
                    selectionColumnDef={{
                      pinned: "left",
                    }}
                    overlayNoRowsTemplate={"No products found."}
                    autoSizeStrategy={autoSizeStrategy}
                    getRowStyle={(params) => {
                      // Check if row has pending orders (priority: light yellow background)
                      const hasOrders = params.data.imp_customerOrderIds && params.data.imp_customerOrderIds.trim() !== "";
                      
                      if (hasOrders) {
                        return { background: "#fef9e7" }; // Light yellow background
                      }
                      
                      // Other styling rules
                      if (params.data.imp_netProfit < 2) {
                        return { background: "#f4cccc" };
                      }
                      if (
                        params.data.imp_currentPrimeSellPrice > 0 &&
                        params.data.imp_netProfit +
                          params.data.imp_sellingPriceVariation <
                          2
                      ) {
                        return { background: "#f4cccc" };
                      }
                      if (params.data.imp_approvalToListCode === 99) {
                        return { background: "#f4cccc" };
                      }
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FinalAnalysis;
